import React from 'react';
import { formatRoute } from 'react-router-named-routes';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import {
  END_USER_RECIPE_COLLECTIONS_ROUTE,
  END_USER_RECIPE_SINGLE_COLLECTION_ROUTE,
} from '../../services/routes';
import {
  myFavouritesRecipesBoard,
  recipesBoardFirstMealID,
  recipesBoardsForCollectionsScreenComparer,
} from '../../services/smorg_board';
import MyDayRecipeCollectionItem from '../recipes/my_day_recipe_collection_item';
import { useGetSharedBoardsByIDsQuery } from '../../app/smorgAppSyncGraphQLApi';
import {
  useGetEndUserSpaceQuery,
  useGetOwnedRecipesBoardsQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import MyDayPlaceholderCard from './my_day_placeholder_card';
import { SHARED_BOARDS_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const MyDayLatestCollectionsSection = () => {
  const navigate = useNavigate();

  const { data: space, isLoading: isSpaceLoading } = useGetEndUserSpaceQuery();

  const spaceAssignedSharedBoardIDs = space?.sharedRecipesBoardIDs || [];

  const {
    data: spaceAssignedSharedBoards,
    isLoading: isSpaceAssignedSharedBoardsLoading,
  } = useGetSharedBoardsByIDsQuery(spaceAssignedSharedBoardIDs, {
    skip:
      isSpaceLoading ||
      !spaceAssignedSharedBoardIDs ||
      spaceAssignedSharedBoardIDs.length === 0,
    refetchOnMountOrArgChange: SHARED_BOARDS_REFRESH_INTERVAL_SECONDS,
  });

  const onClickBoard = (boardID) => {
    navigate(
      formatRoute(END_USER_RECIPE_SINGLE_COLLECTION_ROUTE, {
        boardID,
      }),
    );
  };

  const { data: ownedRecipesBoards, isLoading: isOwnedRecipesBoardsLoading } =
    useGetOwnedRecipesBoardsQuery();

  const myFavouritesBoardID = myFavouritesRecipesBoard(ownedRecipesBoards)?.id;

  const boards = [
    ...(ownedRecipesBoards || []),
    ...(spaceAssignedSharedBoards || []),
  ].sort(recipesBoardsForCollectionsScreenComparer);

  return (
    <>
      <Grid container>
        <Grid item xs={8}>
          <h2
            style={{
              margin: '23px 23px 5px',
              color: 'var(--app-primary-font-color)',
            }}>
            Latest Collections
          </h2>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          <Box sx={{ margin: '28px 10px 5px' }}>
            <Link to={END_USER_RECIPE_COLLECTIONS_ROUTE}>View all</Link>
          </Box>
        </Grid>
      </Grid>
      {isSpaceLoading ||
      isSpaceAssignedSharedBoardsLoading ||
      isOwnedRecipesBoardsLoading ? (
        <div style={{ overflowX: 'auto', display: 'flex' }}>
          <div style={{ flexShrink: 0 }}>
            <MyDayPlaceholderCard />
          </div>
          <div style={{ flexShrink: 0 }}>
            <MyDayPlaceholderCard />
          </div>
        </div>
      ) : (
        <div
          style={{ overflowX: 'auto', display: 'flex' }}
          className="my-day-collections">
          {boards.map((board) => {
            const firstMealID =
              board.id !== myFavouritesBoardID &&
              recipesBoardFirstMealID(board);
            return (
              <div key={board.id} style={{ flexShrink: 0 }}>
                <MyDayRecipeCollectionItem
                  boardID={board.id}
                  title={board.title}
                  firstMealID={firstMealID}
                  onClickBoard={() => onClickBoard(board.id)}
                  isFavourite={board.id === myFavouritesBoardID}
                  isSharedBoard={(spaceAssignedSharedBoardIDs || []).includes(
                    board.id,
                  )}
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default MyDayLatestCollectionsSection;
